// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AuditNode_container__\\+dnF7 {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
}

.AuditNode_header__0fCg2 {
  background-color: #1053ad;
  padding: 16px 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.AuditNode_headerContent__0-OwK {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}
.AuditNode_headerContent__0-OwK h1 {
  color: white;
  margin: 0;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  flex: 1 1;
}

.AuditNode_backButton__E3dXf, .AuditNode_logoutButton__Hk8LZ {
  background: transparent;
  border: 2px solid white;
  color: white;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}
.AuditNode_backButton__E3dXf:hover, .AuditNode_logoutButton__Hk8LZ:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
}

.AuditNode_logoutButton__Hk8LZ {
  background-color: rgba(255, 255, 255, 0.1);
}
.AuditNode_logoutButton__Hk8LZ:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.AuditNode_content__\\+2c2E {
  flex: 1 1;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.AuditNode_tabContainer__mlErP {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.AuditNode_tabs__Ncl-p {
  display: flex;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
}

.AuditNode_tab__FPNVL {
  flex: 1 1;
  padding: 16px 20px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: #666;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
}
.AuditNode_tab__FPNVL:hover {
  background-color: rgba(16, 83, 173, 0.05);
  color: #1053ad;
}
.AuditNode_tab__FPNVL.AuditNode_active__dQOvG {
  color: #1053ad;
  background-color: white;
  border-bottom-color: #1053ad;
}

.AuditNode_tabContent__aMHeu {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

.AuditNode_auditItem__nLhvc {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
  background: #fafafa;
  transition: all 0.3s ease;
}
.AuditNode_auditItem__nLhvc:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}
.AuditNode_auditItem__nLhvc:last-child {
  margin-bottom: 0;
}

.AuditNode_itemHeader__bHsWj {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.AuditNode_processName__8vfjL {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.AuditNode_status__VZHto {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.AuditNode_statusPending__wn5-U {
  background-color: #fff3cd;
  color: #856404;
}

.AuditNode_statusApproved__UIpZ3 {
  background-color: #d4edda;
  color: #155724;
}

.AuditNode_statusRejected__JfWpG {
  background-color: #f8d7da;
  color: #721c24;
}

.AuditNode_itemInfo__9i\\+JQ {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.AuditNode_infoRow__c3chp {
  display: flex;
  gap: 8px;
}

.AuditNode_label__BWM1i {
  font-weight: 600;
  color: #666;
  min-width: 80px;
}

.AuditNode_rejectReason__GTQzK {
  color: #d32f2f;
  font-style: italic;
}

.AuditNode_itemDescription__1d1fI {
  margin-bottom: 16px;
}
.AuditNode_itemDescription__1d1fI p {
  margin: 8px 0 0 0;
  color: #555;
  line-height: 1.5;
}

.AuditNode_itemActions__yc-5q {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.AuditNode_approveButton__TpGSQ, .AuditNode_rejectButton__Db2Qj {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}
.AuditNode_approveButton__TpGSQ:hover, .AuditNode_rejectButton__Db2Qj:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.AuditNode_approveButton__TpGSQ {
  background-color: #4caf50;
  color: white;
}
.AuditNode_approveButton__TpGSQ:hover {
  background-color: #45a049;
}

.AuditNode_rejectButton__Db2Qj {
  background-color: #f44336;
  color: white;
}
.AuditNode_rejectButton__Db2Qj:hover {
  background-color: #d32f2f;
}

.AuditNode_feedbackItem__GzMlZ {
  border-left: 4px solid #ff9800;
  background: linear-gradient(135deg, #fff8e1 0%, #ffffff 100%);
}
.AuditNode_feedbackItem__GzMlZ:hover {
  box-shadow: 0 4px 20px rgba(255, 152, 0, 0.15);
}

.AuditNode_processItem__E0AIN {
  border-left: 4px solid #2196f3;
  background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%);
}
.AuditNode_processItem__E0AIN:hover {
  box-shadow: 0 4px 20px rgba(33, 150, 243, 0.15);
}

.AuditNode_feedbackIcon__Qs9k6 {
  margin-right: 8px;
  font-size: 16px;
}

.AuditNode_emptyState__itl\\+n {
  text-align: center;
  padding: 40px 20px;
  color: #999;
  font-size: 16px;
}

.AuditNode_loadingContainer__pPeZ3 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.AuditNode_loadingContainer__pPeZ3 p {
  font-size: 16px;
  color: #666;
}

@media (max-width: 768px) {
  .AuditNode_headerContent__0-OwK h1 {
    font-size: 20px;
  }
  .AuditNode_content__\\+2c2E {
    padding: 15px;
  }
  .AuditNode_tabs__Ncl-p {
    flex-direction: column;
  }
  .AuditNode_tab__FPNVL {
    border-bottom: 1px solid #e0e0e0;
    border-right: none;
  }
  .AuditNode_tab__FPNVL.AuditNode_active__dQOvG {
    border-bottom-color: #e0e0e0;
    border-left: 3px solid #1053ad;
  }
  .AuditNode_tabContent__aMHeu {
    padding: 15px;
  }
  .AuditNode_auditItem__nLhvc {
    padding: 15px;
  }
  .AuditNode_itemHeader__bHsWj {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .AuditNode_itemInfo__9i\\+JQ {
    grid-template-columns: 1fr;
  }
  .AuditNode_itemActions__yc-5q {
    flex-direction: column;
    gap: 8px;
  }
  .AuditNode_itemActions__yc-5q .AuditNode_approveButton__TpGSQ, .AuditNode_itemActions__yc-5q .AuditNode_rejectButton__Db2Qj {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/AuditNode/index.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,wCAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AACF;AACE;EACE,YAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AACJ;;AAGA;EACE,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AAAF;AAEE;EACE,0CAAA;EACA,2BAAA;AAAJ;;AAIA;EACE,0CAAA;AADF;AAGE;EACE,0CAAA;AADJ;;AAKA;EACE,SAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AAFF;;AAKA;EACE,iBAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;AAFF;;AAKA;EACE,SAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,oCAAA;AAFF;AAIE;EACE,yCAAA;EACA,cAAA;AAFJ;AAKE;EACE,cAAA;EACA,uBAAA;EACA,4BAAA;AAHJ;;AAOA;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AAJF;AAME;EACE,yCAAA;EACA,2BAAA;AAJJ;AAOE;EACE,gBAAA;AALJ;;AASA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AANF;;AASA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AANF;;AASA;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AANF;;AASA;EACE,yBAAA;EACA,cAAA;AANF;;AASA;EACE,yBAAA;EACA,cAAA;AANF;;AASA;EACE,yBAAA;EACA,cAAA;AANF;;AASA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AANF;;AASA;EACE,aAAA;EACA,QAAA;AANF;;AASA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AANF;;AASA;EACE,cAAA;EACA,kBAAA;AANF;;AASA;EACE,mBAAA;AANF;AAQE;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;AANJ;;AAUA;EACE,aAAA;EACA,SAAA;EACA,yBAAA;AAPF;;AAUA;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAPF;AASE;EACE,2BAAA;EACA,yCAAA;AAPJ;;AAWA;EACE,yBAAA;EACA,YAAA;AARF;AAUE;EACE,yBAAA;AARJ;;AAYA;EACE,yBAAA;EACA,YAAA;AATF;AAWE;EACE,yBAAA;AATJ;;AAaA;EACE,8BAAA;EACA,6DAAA;AAVF;AAYE;EACE,8CAAA;AAVJ;;AAcA;EACE,8BAAA;EACA,6DAAA;AAXF;AAaE;EACE,+CAAA;AAXJ;;AAgBA;EACE,iBAAA;EACA,eAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAbF;;AAgBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAbF;AAeE;EACE,eAAA;EACA,WAAA;AAbJ;;AAkBA;EAEI;IACE,eAAA;EAhBJ;EAoBA;IACE,aAAA;EAlBF;EAqBA;IACE,sBAAA;EAnBF;EAsBA;IACE,gCAAA;IACA,kBAAA;EApBF;EAsBE;IACE,4BAAA;IACA,8BAAA;EApBJ;EAwBA;IACE,aAAA;EAtBF;EAyBA;IACE,aAAA;EAvBF;EA0BA;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;EAxBF;EA2BA;IACE,0BAAA;EAzBF;EA4BA;IACE,sBAAA;IACA,QAAA;EA1BF;EA4BE;IACE,WAAA;EA1BJ;AACF","sourcesContent":[".container {\n  width: 100%;\n  min-height: 100vh;\n  background: #f5f5f5;\n  display: flex;\n  flex-direction: column;\n}\n\n.header {\n  background-color: #1053ad;\n  padding: 16px 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.headerContent {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1200px;\n  margin: 0 auto;\n\n  h1 {\n    color: white;\n    margin: 0;\n    font-size: 24px;\n    font-weight: bold;\n    text-align: center;\n    flex: 1;\n  }\n}\n\n.backButton, .logoutButton {\n  background: transparent;\n  border: 2px solid white;\n  color: white;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.3s ease;\n\n  &:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n    transform: translateY(-1px);\n  }\n}\n\n.logoutButton {\n  background-color: rgba(255, 255, 255, 0.1);\n\n  &:hover {\n    background-color: rgba(255, 255, 255, 0.2);\n  }\n}\n\n.content {\n  flex: 1;\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.tabContainer {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.tabs {\n  display: flex;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.tab {\n  flex: 1;\n  padding: 16px 20px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  color: #666;\n  transition: all 0.3s ease;\n  border-bottom: 3px solid transparent;\n\n  &:hover {\n    background-color: rgba(16, 83, 173, 0.05);\n    color: #1053ad;\n  }\n\n  &.active {\n    color: #1053ad;\n    background-color: white;\n    border-bottom-color: #1053ad;\n  }\n}\n\n.tabContent {\n  padding: 20px;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.auditItem {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 16px;\n  background: #fafafa;\n  transition: all 0.3s ease;\n\n  &:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    transform: translateY(-2px);\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.itemHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.processName {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n}\n\n.status {\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.statusPending {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.statusApproved {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.statusRejected {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.itemInfo {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.infoRow {\n  display: flex;\n  gap: 8px;\n}\n\n.label {\n  font-weight: 600;\n  color: #666;\n  min-width: 80px;\n}\n\n.rejectReason {\n  color: #d32f2f;\n  font-style: italic;\n}\n\n.itemDescription {\n  margin-bottom: 16px;\n\n  p {\n    margin: 8px 0 0 0;\n    color: #555;\n    line-height: 1.5;\n  }\n}\n\n.itemActions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.approveButton, .rejectButton {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  }\n}\n\n.approveButton {\n  background-color: #4caf50;\n  color: white;\n\n  &:hover {\n    background-color: #45a049;\n  }\n}\n\n.rejectButton {\n  background-color: #f44336;\n  color: white;\n\n  &:hover {\n    background-color: #d32f2f;\n  }\n}\n\n.feedbackItem {\n  border-left: 4px solid #ff9800;\n  background: linear-gradient(135deg, #fff8e1 0%, #ffffff 100%);\n\n  &:hover {\n    box-shadow: 0 4px 20px rgba(255, 152, 0, 0.15);\n  }\n}\n\n.processItem {\n  border-left: 4px solid #2196f3;\n  background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 100%);\n\n  &:hover {\n    box-shadow: 0 4px 20px rgba(33, 150, 243, 0.15);\n  }\n}\n\n\n.feedbackIcon {\n  margin-right: 8px;\n  font-size: 16px;\n}\n\n.emptyState {\n  text-align: center;\n  padding: 40px 20px;\n  color: #999;\n  font-size: 16px;\n}\n\n.loadingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n\n  p {\n    font-size: 16px;\n    color: #666;\n  }\n}\n\n// 响应式设计\n@media (max-width: 768px) {\n  .headerContent {\n    h1 {\n      font-size: 20px;\n    }\n  }\n\n  .content {\n    padding: 15px;\n  }\n\n  .tabs {\n    flex-direction: column;\n  }\n\n  .tab {\n    border-bottom: 1px solid #e0e0e0;\n    border-right: none;\n\n    &.active {\n      border-bottom-color: #e0e0e0;\n      border-left: 3px solid #1053ad;\n    }\n  }\n\n  .tabContent {\n    padding: 15px;\n  }\n\n  .auditItem {\n    padding: 15px;\n  }\n\n  .itemHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .itemInfo {\n    grid-template-columns: 1fr;\n  }\n\n  .itemActions {\n    flex-direction: column;\n    gap: 8px;\n\n    .approveButton, .rejectButton {\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AuditNode_container__+dnF7`,
	"header": `AuditNode_header__0fCg2`,
	"headerContent": `AuditNode_headerContent__0-OwK`,
	"backButton": `AuditNode_backButton__E3dXf`,
	"logoutButton": `AuditNode_logoutButton__Hk8LZ`,
	"content": `AuditNode_content__+2c2E`,
	"tabContainer": `AuditNode_tabContainer__mlErP`,
	"tabs": `AuditNode_tabs__Ncl-p`,
	"tab": `AuditNode_tab__FPNVL`,
	"active": `AuditNode_active__dQOvG`,
	"tabContent": `AuditNode_tabContent__aMHeu`,
	"auditItem": `AuditNode_auditItem__nLhvc`,
	"itemHeader": `AuditNode_itemHeader__bHsWj`,
	"processName": `AuditNode_processName__8vfjL`,
	"status": `AuditNode_status__VZHto`,
	"statusPending": `AuditNode_statusPending__wn5-U`,
	"statusApproved": `AuditNode_statusApproved__UIpZ3`,
	"statusRejected": `AuditNode_statusRejected__JfWpG`,
	"itemInfo": `AuditNode_itemInfo__9i+JQ`,
	"infoRow": `AuditNode_infoRow__c3chp`,
	"label": `AuditNode_label__BWM1i`,
	"rejectReason": `AuditNode_rejectReason__GTQzK`,
	"itemDescription": `AuditNode_itemDescription__1d1fI`,
	"itemActions": `AuditNode_itemActions__yc-5q`,
	"approveButton": `AuditNode_approveButton__TpGSQ`,
	"rejectButton": `AuditNode_rejectButton__Db2Qj`,
	"feedbackItem": `AuditNode_feedbackItem__GzMlZ`,
	"processItem": `AuditNode_processItem__E0AIN`,
	"feedbackIcon": `AuditNode_feedbackIcon__Qs9k6`,
	"emptyState": `AuditNode_emptyState__itl+n`,
	"loadingContainer": `AuditNode_loadingContainer__pPeZ3`
};
export default ___CSS_LOADER_EXPORT___;
